<script>
	import { writable } from 'svelte/store'
	import { onMount, onDestroy, getContext } from "svelte";
	import { addOverlay, globalOverlay, removeOverlay, getMap } from "../map";
	import PerceptoMarker from '../components/PerceptoMarker.svelte';


	let globalFeed = getContext("GlobalFeed");
	let drones = {}

	const DRONE_MAX_SEEN = 10000
	const CLEANUP_TIMEOUT = 5000
	let cleanupTimeout

	const trackStore = writable({})
	let layer;
	onMount(() => {
		layer = L.layerGroup();
		addOverlay("Percepto", layer, globalOverlay);
		layer.addTo(getMap())

		globalFeed.addEventListener("PERCEPTO", onPerceptoTrack)
		cleanupTimeout = cleanup()
	});
	onDestroy(() => {
		removeOverlay(layer, globalOverlay)
		layer.removeFrom(getMap())

		globalFeed.removeEventListener("PERCEPTO", onPerceptoTrack)
		clearTimeout(cleanupTimeout)
	})

	trackStore.subscribe(t => {
		window.percepto = t
	})

	function onPerceptoTrack(event) {
		console.log(event)
		if (!event.detail.droneId) return
		drones[event.detail.droneId] = Date.now()

		trackStore.update(s => {
			s[event.detail.droneId] = event.detail
			return s
		})
	}

	function cleanup() {
		const now = Date.now()
		const needsClear = []
		for (const [droneId, timeout] of Object.entries(drones)) {
			if (timeout < now - DRONE_MAX_SEEN) needsClear.push(droneId)
		}

		if (needsClear.length) {
			trackStore.update(allHits => {
				for (const droneId of needsClear) {
					console.log("Removing ", droneId)
					delete allHits[droneId]
					delete drones[droneId]
				}
				return allHits
			})
		}

		setTimeout(() => cleanup(), CLEANUP_TIMEOUT)
	}

</script>

{#each Object.values($trackStore) as info}
	<PerceptoMarker {info} {layer} />
{/each}